export default __webpack_public_path__ + "static/media/behind-the-waves.830a5f45.jpg";